import React from "react";
import { Form, Modal } from "antd";
import api from '../../api/api/index';
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import withRecoil from "../../withRecoil";
import { accessTokenState } from "../../atoms";
import queryString from "query-string";
import { withTranslation } from 'react-i18next';

function error(title, content) {
    Modal.error({ title, content });
}

class EnterOtpComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        const { t } = this.props;

        this.props.form.validateFields((err, values) => {
            if (!err) {
                const finalBody = {
                    otp: values.otp,
                    access_token: this.props.recoilStates.accessTokenState.state,
                };

                fetch(`${api.main}/check_otp`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    body: queryString.stringify(finalBody),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((res) => {
                        if (res.status !== 104) {
                            error(t('common:error'), res.message);
                        } else {
                            this.props.tokenAction(this.props.token).then(() => {
                                Modal.success({
                                    title: t('common:success'),
                                    content: t('enterOtp:verified'),
                                    onOk: () => {
                                        this.props.history.push({ pathname: "/spare" });
                                    },
                                });
                            });
                        }
                    })
                    .catch(() => {
                        error(t('common:error'), t('enterOtp:otpIncorrect'));
                    });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;

        return (
            <div className="container mt-5">
                <div className="spare-dvs vh-100 align-items-start">
                    <div className="w-100 float-left">
                        <h2>{t('enterOtp:title')}</h2>
                        <p>{t('enterOtp:note')}</p>

                        <div className="email-dvs">
                            <Form onSubmit={this.handleFormSubmit}>
                                <Form.Item>
                                    {getFieldDecorator('otp', {
                                        rules: [
                                            {
                                                required: true,
                                                message: t('enterOtp:validation'),
                                            },
                                        ],
                                    })(
                                        <p>
                                            <input type="number" inputmode="numeric" placeholder={t('enterOtp:placeholder')} />
                                        </p>,
                                    )}
                                </Form.Item>

                                <div className="btn-enter w-100 float-left">
                                    <input
                                        type="submit"
                                        value={t('enterOtp:submit')}
                                        name=""
                                        onClick={this.handleFormSubmit}
                                    />
                                </div>
                            </Form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const WrappedEnterOtpForm = Form.create({ name: 'enter_otp_form' })(EnterOtpComponent);

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ tokenAction }, dispatch);

const mapStateToProps = (state) => ({ token: state.token });

// withTranslation must wrap the concrete component before withRouter/withRecoil/connect
const I18nWrapped = withTranslation(['enterOtp', 'common'])(WrappedEnterOtpForm);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withRecoil(I18nWrapped, [accessTokenState])));
